import React, { useState } from 'react';
import { motion } from 'framer-motion';

const MapsDemo = () => {
  const [activeTab, setActiveTab] = useState('create');
  const [output, setOutput]     = useState('');

  const tabs = [
    { key: 'create', label: 'Создать' },
    { key: 'access', label: 'Доступ/Проверка' },
    { key: 'delete', label: 'Удалить' },
    { key: 'iterate', label: 'Итерация' },
    { key: 'sort',   label: 'Сортировать' },
    { key: 'copy',   label: 'Копировать' },
  ];

  const examples = {
    create: {
      code: `// Создаем пустую карту
myMap := make(map[string]int)
// Заполняем
myMap["яблоки"] = 5
myMap["бананы"] = 10
fmt.Println(myMap) // map[яблоки:5 бананы:10]`,
      run: () => setOutput('map[яблоки:5 бананы:10]'),
    },
    access: {
      code: `// Доступ к элементам
count := myMap["яблоки"]
fmt.Println("Яблоки:", count) // Яблоки: 5
// Проверка
_, ok := myMap["груши"]
fmt.Println("Груши есть?", ok) // false`,
      run: () => setOutput('Яблоки: 5 | груши: not found'),
    },
    delete: {
      code: `// Удаляем элемент
delete(myMap, "бананы")
fmt.Println(myMap) // map[яблоки:5]`,
      run: () => setOutput('map[яблоки:5]'),
    },
    iterate: {
      code: `// Перебор ключей и значений
for k, v := range myMap {
  fmt.Println(k, v)
}`,
      run: () => setOutput('яблоки 5'),
    },
    sort: {
      code: `// Сортировка ключей
keys := make([]string, 0, len(myMap))
for k := range myMap { keys = append(keys, k) }
sort.Strings(keys)
for _, k := range keys {
  fmt.Println(k, myMap[k])
}`,
      run: () => setOutput('яблоки 5'),
    },
    copy: {
      code: `// Клонирование карты
orig := map[string]int{"A":1,"B":2}
clone := make(map[string]int)
for k,v := range orig { clone[k]=v }
clone["A"]=100
fmt.Println(orig, clone)
// map[A:1 B:2] map[A:100 B:2]`,
      run: () => setOutput('orig[A:1 B:2] clone[A:100 B:2]'),
    },
  };

  const { code, run } = examples[activeTab];

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Демо: Карты в Go</h3>

      <div style={styles.tabList}>
        {tabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => { setActiveTab(tab.key); setOutput(''); }}
            style={activeTab === tab.key ? styles.activeTab : styles.tab}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <pre style={styles.codeBlock}>
        <code>{code}</code>
      </pre>

      <button onClick={run} style={styles.runButton}>
        Выполнить
      </button>

      {output && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          style={styles.output}
        >
          <strong>Результат:</strong> {output}
        </motion.div>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: 700,
    margin: '2rem auto',
    padding: '1rem',
    background: '#fff',
    borderRadius: 12,
    border: '2px solid black',
  },
  title: {
    textAlign: 'center',
    marginBottom: '1rem',
  },
  tabList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    justifyContent: 'center',
    marginBottom: '1rem',
  },
  tab: {
    padding: '0.5rem 1rem',
    border: '1px solid #ccc',
    borderRadius: 6,
    background: '#f0f0f0',
    cursor: 'pointer',
  },
  activeTab: {
    padding: '0.5rem 1rem',
    border: '1px solid black',
    borderRadius: 6,
    background: 'black',
    color: '#fff',
    cursor: 'pointer',
    fontFamily: 'Roboto, monospace'
  },
  codeBlock: {
    background: '#f5f5f5',
    padding: '1rem',
    borderRadius: 6,
    overflowX: 'auto',
  },
  runButton: {
    marginTop: '1rem',
    padding: '0.5rem 1rem',
    border: 'none',
    borderRadius: 6,
    background: 'black',
    color: '#fff',
    cursor: 'pointer',
    fontFamily: 'Roboto, monospace'
  },
  output: {
    marginTop: '1rem',
    padding: '0.75rem',
    background: '#f5f5f5',
    borderRadius: 6,
    fontFamily: 'monospace',
  },
};

export default MapsDemo;
